import createStatusChipSelect from '@/components/statuses/factory/createStatusChipSelect';
import GeneralStatus from '@/components/statuses/GeneralStatus/GeneralStatus';
import GENERAL_STATUSES from '@/components/statuses/GeneralStatus/options';

const GeneralStatusSelect = createStatusChipSelect({
  options: GENERAL_STATUSES,
  defaultSx: {
    gap: ({ spacing }) => spacing(2)
  },
  StatusIndicatorComponent: GeneralStatus,
  translationNamespace: 'filters'
});

export default GeneralStatusSelect;
